<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    @if (errorMessage) {
      <div hlmCard>
        <div hlmCardHeader>
          <h1 hlmCardTitle>Einladung konnte nicht geöffnet werden</h1>
        </div>

        <div hlmCardContent class="space-y-4">
          <div hlmAlert variant="destructive">
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>{{ errorMessage }}</p>
          </div>

          <a hlmBtn variant="outline" class="w-full" routerLink="/voucher-dashboard">
            Zum Dashboard
          </a>
        </div>
      </div>
    }
  </div>
</div>
